import { useTranslations } from 'utils';

import './SurchargeError.scss';

type ErrorProps = {
  status?: 'failed' | 'declined' | 'balance';
  onRetry: () => void;
  onChangePaymentMethod: () => void;
};

export function SurchargeError({
  status = 'failed',
  onChangePaymentMethod,
  onRetry,
}: ErrorProps) {
  const i18n = useTranslations();

  return (
    <div>
      <div className="CardPayment-Error">
        <h3 className="failed" tabIndex={0} aria-describedby="failureMessage">
          {i18n.t('surcharge.tokenization.error.title')}
        </h3>
        <p id="failureMessage">{i18n.t(`surcharge.payment.error.${status}`)}</p>
        <div className="Error-links">
          <button
            className="Error-link"
            onClick={onRetry}
            data-testid="retryBtn"
            type="button"
          >
            {i18n.t('surcharge.payment.error.retry')}
          </button>
          <div>{i18n.t('surcharge.tokenization.error.or')}</div>
          <button
            className="Error-link"
            onClick={onChangePaymentMethod}
            data-testid="changePaymentMethodBtn"
            type="button"
          >
            {i18n.t('surcharge.payment.changePaymentMethod')}
          </button>
        </div>
      </div>
    </div>
  );
}
